import Styles from "./Login.module.scss";
import clsx from "clsx";
import Loading from "../../../Share/Component/Loading";
import useAdminLoginPage from "../../../Hooks/useAdminLoginPage";
import ReCAPTCHA from "react-google-recaptcha";
import { Controller } from "react-hook-form";
import { LoginInput } from "../../../Components/Atoms/LoginInput";

function AdminLogin() {
  const { loading, reCaptchaV2, control, handleSubmit } = useAdminLoginPage();

  return (
    <>
      {loading ? <Loading /> : null}
      <div className={clsx(Styles.main)}>
        <div className={clsx(Styles.formBox)}>
          <div className={clsx(Styles.formValue)}>
            <h2>ĐĂNG NHẬP</h2>
            <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
              <Controller
                name="userName"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="TÀI KHOẢN"
                    id="userName"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                  />
                )}
              />
              <Controller
                name="password"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="MẬT KHẨU"
                    id="password"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    type="password"
                  />
                )}
              />

              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY_V2}
                ref={reCaptchaV2}
              />

              <button className={clsx(Styles.btnSubmit)} type="submit">
                Xác nhận
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default AdminLogin;
